module.exports = __webpack_public_path__ + "img/Grupo 1664@2x.a001b40f.png";